const HOSTINGER_API_URL = process.env.REACT_APP_API_URL || 'https://onyxcrm.onyxmachinery.in/api.php';

const apiCall = async (action, payload = null) => {
  if (HOSTINGER_API_URL) {
      try {
          const options = {
            method: payload ? 'POST' : 'GET',
            headers: { 'Content-Type': 'application/json' },
          };
          if (payload) options.body = JSON.stringify(payload);
          const response = await fetch(`${HOSTINGER_API_URL}?action=${action}`, options);
          
          if (response.ok) {
              const result = await response.json();
              if (result.success) {
                  return result.data;
              }
          }
      } catch (error) {
          console.error("API Error:", error);
      }
  }
  return null;
};

export { apiCall };
